import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import useSeo from "@/hooks/useSeo";
import { SITE_EMAIL, SITE_NAME, SITE_URL, allTopics, sortByHeat } from "@/lib/site";
import HeroSection from "./components/HeroSection";
import HotRanking from "./components/HotRanking";
import CategoryGrid from "./components/CategoryGrid";
import LatestFeed from "./components/LatestFeed";
import FeaturedTopics from "./components/FeaturedTopics";
import FaqPreview from "./components/FaqPreview";
import CtaBand from "./components/CtaBand";

export default function Home() {
  const ranked = sortByHeat(allTopics).slice(0, 6);

  useSeo({
    title: "网曝吃瓜进展追踪_事件后续与最新动态｜瓜田雷达",
    description:
      "网曝吃瓜进展、后续与发酵全过程追踪，瓜田雷达为你梳理事件脉络：从最初的说法到当事方回应、争议澄清再到最新动态，所有节点按时间排列并标注信息来源类型，帮你快速看清一件事走到了哪一步，不再错过关键后续。",
    keywords: "网曝吃瓜,吃瓜进展,吃瓜后续,事件发酵,吃瓜追踪,最新动态,网曝吃瓜进展",
    path: "/",
    jsonLd: [
      {
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_URL,
        inLanguage: "zh-CN",
        description: "网曝吃瓜事件的进展、后续与最新动态时间线追踪站。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_URL}/topics?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_URL,
        email: SITE_EMAIL,
        description:
          "以时间线方式整理网络热点事件的进展与后续，只呈现可追溯的公开信息，不做评价与定性。",
      },
      {
        "@type": "ItemList",
        name: "今日热榜",
        itemListOrder: "https://schema.org/ItemListOrderDescending",
        numberOfItems: ranked.length,
        itemListElement: ranked.map((topic, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: topic.title,
          url: `${SITE_URL}/topic/${topic.id}`,
        })),
      },
    ],
  });

  return (
    <>
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRanking />
        <CategoryGrid />
        <LatestFeed />
        <FeaturedTopics />
        <FaqPreview />
        <CtaBand />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}